import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';


if (environment.production) {
  enableProdMode();
}
if (environment.baseUrl && environment.baseUrl.includes('mpgpsr')) {
  console.log = () => {};
  console.warn = () => {};
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
